import type { ReactNode } from 'react';

type Props = {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  /** top = field icons; left = menu item icons (avoids scroll clipping). */
  placement?: 'top' | 'left';
};

/** CSS-only hover tooltip — avoids MUI portal DOM churn inside menus/popovers. */
const VNFieldHelpHoverTip = ({ title, children, className, placement = 'top' }: Props) => {
  const hasTitle = title != null && title !== '';

  const rootClass = [
    'vn-field-help__hover-tip',
    placement === 'left' && 'vn-field-help__hover-tip--left',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // Always render the same wrapper — avoids React reconciler churn (insertBefore errors).
  return (
    <span className={rootClass}>
      {children}
      {hasTitle && (
        <span className="vn-field-help__hover-tip-bubble" role="tooltip">
          {title}
        </span>
      )}
    </span>
  );
};

export default VNFieldHelpHoverTip;
